
import ApplicationController from '../application_controller.js';
import { Controller } from "stimulus";
import { Janus } from 'janus-gateway';
import {Socket} from "phoenix";
import throttle from 'lodash/throttle';


export default class extends ApplicationController {
  initialize() {
    this.monitorOnlineState(); // Monitor online state of the browser
  }

  monitorOnlineState() {

    window.addEventListener('offline', (e) => {
      var connectionState = document.getElementById('connectionstate');
      connectionState.classList.remove('d-none');
      connectionState.classList.add('d-flex');
    });
    
    window.addEventListener('online', (e) => {
      var connectionState = document.getElementById('connectionstate');
      connectionState.classList.remove('d-flex');
      connectionState.classList.add('d-none');
    });
  }

}


